exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delete-pipeline-template-modal__delete-error {\n  color: var(--color-danger);\n}\n", ""]);

